class ModuleCalcElement {
    constructor () {
        this.calcWidth();
        this.calcHeight();
    }

    calcWidth(){
        this.objsWidth = document.querySelectorAll('.calc-width');
        this.updateWidths();

        window.addEventListener('resize', () => this.updateWidths());
    }

    calcHeight(){
        this.objsHeight = document.querySelectorAll('.calc-height');
        this.updateHeights();
        
        // Lắng nghe sự kiện resize một lần
        window.addEventListener('resize', () => this.updateHeights());
    }

    updateHeights() {
        this.objsHeight.forEach((obj) => {
            const dataName = obj.getAttribute('data-name');
            setTimeout(() => {
                document.body.style.setProperty(`--${dataName}`, `${obj.clientHeight}px`);
            });
        });
    }
    updateWidths() {
        this.objsWidth.forEach((obj) => {
            const dataName = obj.getAttribute('data-name');
            setTimeout(() => {
                document.body.style.setProperty(`--${dataName}`, `${obj.clientWidth}px`);
            });
        });
    }
}


export default ModuleCalcElement;